import * as e from "react";
import t from "../lib/IconBase.es.js";
import f from "../defs/Leaf.es.js";
const o = e.forwardRef((a, r) => /* @__PURE__ */ e.createElement(t, { ref: r, ...a, weights: f }));
o.displayName = "LeafIcon";
const s = o;
export {
  s as Leaf,
  o as LeafIcon
};
